module.exports = __webpack_public_path__ + "img/exhibition4.9d28cbd7.png";